import { render, staticRenderFns } from "./StaffRideAnalyticsCard.vue?vue&type=template&id=2539562a&scoped=true"
import script from "./StaffRideAnalyticsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffRideAnalyticsCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2539562a",
  null
  
)

export default component.exports